// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fofXs{width:28px;height:28px;border-radius:8px;background:#f4f4f7;color:#535382}.nzgTS{margin-left:auto;height:12px}.qpFab{width:3px;border-radius:1px;background:#d4d4e0}.qpFab.REwXW{height:6px}.qpFab.sIbFk{height:9px}.qpFab.HTWMZ{height:12px}.qpFab.Y2DQm{background:#6942f8}.qYcEK{background-image:linear-gradient(135deg, #2cf1ff 0%, #7856f9 50%, #ff5f8f 100%);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;font-variant-numeric:tabular-nums}.mDyb_{margin-top:auto;flex-wrap:wrap}.wNu7o{margin-left:auto}.wAZg8{min-height:0}.wAZg8.rKMl7{pointer-events:none;animation:f22WU 120ms cubic-bezier(0.4, 0, 1, 1) both}.wAZg8.Z4tgW{animation:DX57W 280ms cubic-bezier(0.22, 1, 0.36, 1) both}@keyframes f22WU{from{opacity:1;transform:none}to{opacity:0;transform:translateY(-4px)}}@keyframes DX57W{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"kindIcon": `fofXs`,
	"confidence": `nzgTS`,
	"confidenceBar": `qpFab`,
	"shortBar": `REwXW`,
	"middleBar": `sIbFk`,
	"tallBar": `HTWMZ`,
	"filled": `Y2DQm`,
	"amount": `qYcEK`,
	"actions": `mDyb_`,
	"next": `wNu7o`,
	"cardText": `wAZg8`,
	"leaving": `rKMl7`,
	"content-leave": `f22WU`,
	"entering": `Z4tgW`,
	"content-enter": `DX57W`
};
export default ___CSS_LOADER_EXPORT___;
